import React from "react";

import { Tab, Tooltip } from "@mui/material";
import { makeStyles } from "tss-react/mui";

const TAB_WIDTH = 164;

interface Props {
  activeTab: number;
  hasDetails?: boolean;
  onChangeTab: (index: number) => void;
}

const useStyles = makeStyles()((theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(2),
    position: "relative",
  },
  tabs: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  tab: {
    minHeight: 32,
    maxHeight: 32,
    minWidth: TAB_WIDTH,
    display: "flex",
    marginRight: -(TAB_WIDTH * 0.1), // tab width * trapezoid clip path 10%
    backgroundColor: "white",
    textTransform: "initial",
  },
  activeTab: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    opacity: 1,
  },
  customButtonTabDefault: {
    clipPath: "polygon(10% 0%, 100% 0%, 90% 100%, 0% 100%)",
  },
  customButtonTabShaped: {
    clipPath: "polygon(10% 0, 100% 0%, 90% 100%, 10% 100%)",
    marginLeft: -(TAB_WIDTH * 0.1), // tab width * trapezoid clip path 10%
  },
}));

const Tabs: React.FC<Props> = ({ activeTab, onChangeTab, hasDetails }) => {
  const { classes, cx } = useStyles();

  return (
    <div className={classes.tabs}>
      <Tab
        className={cx(classes.tab, classes.customButtonTabShaped, {
          [classes.activeTab]: activeTab === 0,
        })}
        label="Plan details"
        onClick={() => onChangeTab(0)}
      />
      <Tooltip
        placement="top"
        title={hasDetails ? "" : "Please save plan details to proceed"}
      >
        <span>
          <Tab
            className={cx(classes.tab, classes.customButtonTabDefault, {
              [classes.activeTab]: activeTab === 1,
            })}
            label="Meal plan"
            onClick={() => onChangeTab(1)}
            disabled={!hasDetails}
          />
        </span>
      </Tooltip>
    </div>
  );
};

export default Tabs;
